<template>
  <div >
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <nagusi tipo="home" :estados="estados" @clicked="clicked"></nagusi> -->
    
    <nagusi tipo="" :estados="estados" @clicked="clicked"></nagusi>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
// import principal from '../components/Principal.vue';
import nagusi from '../components/Nagusi.vue';

// import mqtt from 'mqtt'

export default {
  name: 'Home',
  components: {
    nagusi
  },
  props: {
    client: Object,
    estados:Object,
  },
  data() {
    return {
        credentials:{
            'username':localStorage.username,
            'password':localStorage.password,
        },
        subscription: {
            topic: 'general',
            qos: 0,
        },
        //estados:{}
    }
  },
  methods: {
      clicked(p){
        this.$router.push({'path':'/zona','params':{'id':p}})
      },
    doSubscribe() {
      const { topic, qos } = this.subscription;
      this.client.subscribe(topic, { qos }, (error, res) => {
          if (error) {
          console.log('Subscribe to topics error', error)
          return
          }
          this.subscribeSuccess = true
          console.log('Subscribe to topics res', res)
      })
    },
    doUnSubscribe() {
        const { topic } = this.subscription;
        console.log("Desusbcripcion de general");
        this.client.unsubscribe(topic, error => {
            if (error) {
                console.log('Unsubscribe error', error)
            }
        })
    },
    // recepcion(message){
    //     console.log(message);
    //     this.estados=message;
    // }
  },
  mounted(){
      console.log("Home se ha montado");
    //Si no está conectado redirigir a login
    if(!this.client.connected)this.$router.push('login');
    else  {
      this.doSubscribe();
      // this.client.on('message', (topic, message) => { 
      //     console.log("Desde Home")
      //     const msg = JSON.parse(message);
      //     this.recepcion(msg);
      // })
         
    }
  },
  destroyed() {
      console.log("destruyendo Home")
      this.doUnSubscribe();
  }
}
</script>
